"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var rdf_terms_1 = require("rdf-terms");

var BindingsToQuadsIterator_1 = require("./BindingsToQuadsIterator");
/**
 * A comunica Construct Query Operation Actor.
 */


var ActorQueryOperationConstruct =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationConstruct, _bus_query_operation_);

  function ActorQueryOperationConstruct(args) {
    _classCallCheck(this, ActorQueryOperationConstruct);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationConstruct).call(this, args, 'construct'));
  }
  /**
   * Find all variables in a list of triple patterns.
   * @param {Algebra.Pattern[]} patterns An array of triple patterns.
   * @return {RDF.Variable[]} The variables in the triple patterns.
   */


  _createClass(ActorQueryOperationConstruct, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pattern, context) {
        var variables, operation, output, quadStream, metadata;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Apply a projection on our CONSTRUCT variables first, as the query may contain other variables as well.
                variables = ActorQueryOperationConstruct.getVariables(pattern.template);
                operation = {
                  type: 'project',
                  input: pattern.input,
                  variables: variables
                }; // Evaluate the input query

                _context2.t0 = bus_query_operation_1.ActorQueryOperation;
                _context2.next = 5;
                return this.mediatorQueryOperation.mediate({
                  operation: operation,
                  context: context
                });

              case 5:
                _context2.t1 = _context2.sent;
                output = _context2.t0.getSafeBindings.call(_context2.t0, _context2.t1);
                // construct triples using the result based on the pattern.
                quadStream = new BindingsToQuadsIterator_1.BindingsToQuadsIterator(pattern.template, output.bindingsStream); // Let the final metadata contain the estimated number of triples

                metadata = null;

                if (output.metadata) {
                  metadata = function metadata() {
                    return output.metadata().then(function (m) {
                      if (m) {
                        if (m.totalItems) {
                          return Object.assign({}, m, {
                            totalItems: m.totalItems * pattern.template.length
                          });
                        }

                        return m;
                      }

                      return null;
                    });
                  };
                }

                return _context2.abrupt("return", {
                  metadata: metadata,
                  quadStream: quadStream,
                  type: 'quads'
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }], [{
    key: "getVariables",
    value: function getVariables(patterns) {
      return rdf_terms_1.uniqTerms([].concat.apply([], patterns.map(function (pattern) {
        return rdf_terms_1.getVariables(rdf_terms_1.getTerms(pattern));
      })));
    }
  }]);

  return ActorQueryOperationConstruct;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationConstruct = ActorQueryOperationConstruct;